var _path, _path2, _rect, _rect2, _rect3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -30 120 152",
    role: "img",
    "aria-label": "\\u0648\\u0643\\u064A\\u0644 \\u0647\\u0648\\u0633\\u062A \\u0645\\u064A \\u0627\\u0644\\u0630\\u0643\\u064A",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0-12C1.2-3.6 3.6-1.2 12 0 3.6 1.2 1.2 3.6 0 12-1.2 3.6-3.6 1.2-12 0-3.6-1.2-1.2-3.6 0-12Z",
    transform: "translate(60 -12) scale(1.3)",
    fill: "#ff9f53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 6Q60 -3 71 6L107 34C117 41 120 48 120 60V102Q120 120 102 120H18Q0 120 0 102V60C0 48 3 41 13 34Z",
    fill: "#ffffff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 48,
    width: 92,
    height: 58,
    rx: 20,
    fill: "#090040"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 58,
    width: 15,
    height: 23,
    rx: 6.5,
    fill: "#48b58d"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 58,
    width: 15,
    height: 23,
    rx: 6.5,
    fill: "#48b58d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 91Q60 99 70 91",
    stroke: "#48b58d",
    strokeWidth: 6.5,
    strokeLinecap: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentIconDark);
export default __webpack_public_path__ + "static/media/agent-icon-dark.27d7bb3202764295c4becc8bf43c3c5a.svg";
export { ForwardRef as ReactComponent };